import { render, staticRenderFns } from "./site-landpage.vue?vue&type=template&id=2f2b629f&scoped=true"
import script from "./site-landpage.vue?vue&type=script&lang=js"
export * from "./site-landpage.vue?vue&type=script&lang=js"
import style0 from "./site-landpage.vue?vue&type=style&index=0&id=2f2b629f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b629f",
  null
  
)

export default component.exports